import React from "react";
// import DesignTab from "./DesignTab";
import { Tabs, Tab } from "react-bootstrap";
import ModalForm from "./modalForm";
import SourceSelector from "../../sourcePicker/SourceSelector";
import treeStore from '../../../store/treeStore';

/**Handles the different tabs in the modal */
export default class ModalBody extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: null,
            document: false,
            sources: [],
            theme: false,
            themeObject: ""
        };
    }

    async componentWillMount() {
        await this.setState({
            readOnly: this.props.readOnly,
            sourcesAllowed: this.props.sourcesAllowed,
            parent: this.props.parent
        });
        if (this.props.parent === "0") {
            this.setTheming(true);
        } else if (typeof this.props.parent === "string") {
            if (treeStore.tree[this.props.parent].type === "hub") {
                this.setTheming(true);
            }
        }
        if (this.props.edit) {
            if (this.props.parent.type === "hub" || this.props.parent.type === "site") {
                this.setTheming(true);
            }
            if (this.props.parent.type === "docLib") {
                this.setState({ document: true });
                if (this.props.parent.sources !== undefined) {
                    this.setState((prevState) => ({
                        parent: { ...prevState.parent }, sources: this.props.parent.sources
                    }));
                }
            }
        }
        if (this.props.parent.theme) {
            this.setState({ themeObject: this.props.parent.theme });
        }

    }
    setTheming = (boolean) => this.setState({ theme: boolean });

    setSourcesAllowed = (boolean) => this.setState({ sourcesAllowed: boolean });
    documentSetter = boolean => {
        this.setState({ document: boolean });
    };

    onRemoveSource = (sourceObject) => {
        const { parent } = this.state;
        const newSourceArray = parent.sources.filter((source) => {
            if (source.id === sourceObject.id) {
                return false;
            }
            return true;
        });
        this.setState((prevState) => ({
            parent: { ...prevState.parent, sources: newSourceArray },
            lastRemovedSource: sourceObject
        }));
    };
    /**Sets the sources state, will check if already exists */
    onSourceSetter = (sourceObject) => {
        const { parent } = this.state;
        let source = parent.sources || [];
        if (source.length > 0) {
            const findObject = source.filter((sources) => {
                if (sources.id === sourceObject.id) {
                    return true;
                }
                return false;
            });
            if (findObject.length > 0) {
                console.log("object already added");
                return;
            }
        }
        source.push(sourceObject);
        this.setState((prevState) => ({
            parent: { ...prevState.parent, sources: source }
        }));
    };
    render() {
        return (
            <div>
                <Tabs
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}
                    id="controlled-tab"
                >
                    <Tab eventKey={1} title="SharePoint Details">
                        <ModalForm
                            design={this.designSetter}
                            parent={this.state.parent}
                            hide={this.props.hide}
                            image={this.state.image}
                            titleChanger={this.props.titleChanger}
                            documents={this.documentSetter}
                            onRemoveSource={this.onRemoveSource}
                            readOnly={this.state.readOnly}
                            sourcesAllowed={this.state.sourcesAllowed}
                            setShowSource={this.setSourcesAllowed}
                            setTheme={this.setTheming}
                            theme={this.state.themeObject}
                        />
                    </Tab>
                    {/* {this.state.theme ? <Tab eventKey={2} title="Theme Designer">
                        {/* <ThemeDesigner themeChanger={this.changeTheme} theme={this.state.themeObject} /> */}
                    {/* {this.state.design ? (
                        <Tab eventKey={2} title="Design">
                            <DesignTab
                                colour={this.props.colour}
                                id={this.props.parent.id}
                                imageSetter={this.imageSetter}
                            />
                        </Tab>
                    ) : null} */}
                    {this.state.document && this.state.sourcesAllowed ? (
                        <Tab eventKey={3} title="Data Sources">
                            <SourceSelector onSourceSetter={this.onSourceSetter} lastRemovedSource={this.state.lastRemovedSource} />
                            {/* <Form.Label>
                                Data sources, please use a new line for each source
                            </Form.Label>
                            <Form.Control
                                onChange={this.onChangeSources}
                                as="textarea"
                                name="datasources"
                                placeholder="Data Sources"
                                rows={6}
                                value={this.state.parent ? this.state.parent.sources : undefined}
                            /> */}
                            {/* <SourcePicker
                                addHandler={this.sourceSetter}
                                sources={this.props.parent.sources ? this.props.parent.sources : []}
                                width="600"
                                height="400"
                            /> */}
                        </Tab>
                    ) : null}
                </Tabs>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tree/node/modalBody.js